import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=e8a98012&scoped=true"
import script from "./ErrorCard.vue?vue&type=script&lang=js"
export * from "./ErrorCard.vue?vue&type=script&lang=js"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=e8a98012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a98012",
  null
  
)

export default component.exports